import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { PermissionLevels } from 'utils/permission'
import {
  add as addVisitor
} from '../redux/visitors'

export default function * requestAddUserToMyBoard (action) {
  const { id } = action.payload

  const state = yield select()

  if (state['view-myboard'].visitors.indexOf(id) !== -1) return

  const myBoardId = state.kanbo.currentUser.myBoardId

  const optimisticAction = yield optimisticPut(addVisitor({
    id
  }))

  try {
    yield call(apiAction, 'AddVBoardUser', {
      userId: id,
      vBoardId: myBoardId,
      permissionLevel: PermissionLevels.VISITOR
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
